"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  BackBottom: {
    newMsgOne: '{n}条新消息',
    newMsgOther: '{n}条新消息',
    bottom: '回到底部'
  },
  Time: {
    weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    formats: {
      LT: 'HH:mm',
      // 00:32
      lll: 'YYYY年M月D日 HH:mm',
      // 2019年2月22日 00:28
      WT: 'dddd HH:mm',
      // 星期一 00:32
      YT: '昨天 HH:mm' // 昨天 00:32
    }
  },

  Composer: {
    send: '发送'
  },
  SendConfirm: {
    title: '发送图片',
    send: '发送',
    cancel: '取消'
  },
  RateActions: {
    up: '赞同',
    down: '反对'
  },
  Recorder: {
    hold2talk: '按住 说话',
    release2send: '松开 发送',
    releaseOrSwipe: '松开发送，上滑取消',
    release2cancel: '松开手指，取消发送'
  },
  Search: {
    search: '搜索'
  }
};
exports.default = _default;